// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { Numeric, Currency } from 'common/components/Number';
import type { TotalSummary } from 'common/modules/proposition/domain/estimation';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import { Metric, MetricTitle, MetricNumber } from 'common/modules/printing/styles/Metric';


type Props = {
  summary: TotalSummary,
  t: any,
}

function SalesPrintingSummary({ summary, t }: Props) {
  return (
    <PrintingCard>
      <Metric>
        <MetricTitle>{t('numberOfOpportunities')}</MetricTitle>
        <MetricNumber><Numeric roundAt={0} value={summary.numberOfOpportunities} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('totalCost')}</MetricTitle>
        <MetricNumber><Currency value={summary.totalCost} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('costPerThousand')}</MetricTitle>
        <MetricNumber><Currency value={summary.costPerThousand} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('impressions')}</MetricTitle>
        <MetricNumber><Numeric roundAt={0} value={summary.impressions} /></MetricNumber>
      </Metric>
    </PrintingCard>
  );
}

export default withTheme(translate('commonSales')(SalesPrintingSummary));



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/printing/SalesPrintingSummary.js